// removed by extract-text-webpack-plugin
module.exports = {"hidden":"gz9ZD","visuallyhidden":"_2KYnP","hide-text":"_2CUX0","center":"_2gcjp","noprint":"_1HfNj","root":"_3qXzz","buttonlist":"_2Wy_x","listItem":"_2lclr","button":"_1ksJm","linkCopiedMessage":"_3FGgq","cssAnimation":"_2w8fl"};


/*****************
 ** WEBPACK FOOTER
 ** ./themes/ui-share/styles/default.scss
 ** module id = 1015
 ** module chunks = 2
 **/